/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, typography } from '@atlaskit/theme';

export const BranchInfoList = styled.ul`
  padding-left: 0;
  list-style: none;
  display: table;
  margin-bottom: ${gridSize() * 2}px;
`;

export const BranchInfoListItem = styled.li`
  display: table-row;
`;

export const LeftColumn = styled.div`
  display: table-cell;
  text-align: right;
  ${typography.h200() as any};
  padding-right: 0;
  vertical-align: middle;
  padding-top: ${gridSize() / 2}px;
  padding-bottom: ${gridSize() / 2}px;
`;

export const RightColumn = styled.div`
  display: table-cell;
  vertical-align: middle;
  max-width: ${gridSize() * 51}px;
  padding-left: ${gridSize()}px;
  padding-top: ${gridSize() / 2}px;
  padding-bottom: ${gridSize() / 2}px;
`;

// Attempt to match the styles of an AK Button with `appearance="link"` and an icon
export const FormerUser = styled.span`
  align-items: center;
  display: flex;
  padding: ${gridSize() / 2}px ${gridSize()}px;
`;

export const FormerUserAvatar = styled.span`
  /* remove phantom padding from AK avatar to center-align vertically */
  line-height: 0;
  margin: 0 ${gridSize() / 2}px;
`;

export const FormerUserName = styled.span`
  margin: 0 ${gridSize() / 2}px;
`;

export const RetargetBranch = styled.div`
  margin-top: -8px;
`;

export const ReadContainer = styled.div`
  display: inline-flex;
  align-items: center;
  width: 100%;
`;

export const EditContainer = styled.div`
  min-width: 250px;
  max-width: ${gridSize() * 51}px;
`;

export const LinkContainer = styled.div`
  margin: 0 4px;
  padding: 0 8px;
  max-width: ${gridSize() * 51 - 52}px;
`;

export const LinkTextContainer = styled.div`
  display: flex;
  white-space: nowrap;
  max-width: ${gridSize() * 51 - 28}px;
`;

export const LinkTextSpan = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  font-style: normal;
`;

export const Icon = styled.div`
  margin-left: auto;
  margin-right: 0;
  padding-right: 4px;
`;
